import { render, staticRenderFns } from "./open-side.vue?vue&type=template&id=744d22fa&scoped=true&"
import script from "./open-side.vue?vue&type=script&lang=js&"
export * from "./open-side.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744d22fa",
  null
  
)

export default component.exports